import type { Config } from 'tailwindcss'

export default {
  content: [
    './index.html',
    './src/**/*.{ts,tsx}',
  ],
  theme: {
    extend: {
      screens: {
        sm: '720px',
        md: '960px',
        lg: '1360px',
        xl: '1762px',
      },
      colors: {
        'dark-green': '#003225',
        'deep-green': {
          200: '#CCDCD8',
          DEFAULT: '#004F3A'
        },
        'electric-green': '#6AFF9B',
        'soft-green': '#EDF3F1',
        'orange': { // used for bloom pro
          100: '#FFF8EF',
          DEFAULT: '#EF8500',
        },
        'burnt-orange': '#D76220',
        'gray': {
          100: 'rgba(0, 0, 0, 0.1)',
          200: '#A8A8A8',
          300: '#F8F8F8',
          DEFAULT: '#4B5563',
        },
        'white': '#FFFFFF',
        'black': '#000000',
        'error': '#660000',
      },
      borderRadius: {
        lg: '0.875rem',
        sm: '0.225rem',
      }
    },
    fontSize: {
      '3xs': '0.625rem', // 10px
      '2xs': '0.75rem', // 12px
      xs: '0.875rem', // 14px
      sm: '1rem', // 16px
      md: '1.125rem', // 18px
      base: '1.25rem', // 20px
      xl: '1.4rem', //  22.4px
      '2xl': '1.5rem', // 24px
      '3xl': '2rem', // 32px
      '4xl': '2.375rem', // 38px
      '5xl': '2.875rem', // 46px
      '6xl': '3.5rem', // 56px
      '7xl': '4rem', // 64px
    },
    fontFamily: {
      sans: ['"Open Sans"', 'sans-serif'],
      astrid: ['AstridGrotesk', 'sans-serif'],
    },
    animation: {
      'flicker': 'flicker 0.5s infinite',
      'spin': 'spin 1s linear infinite',
    },
    keyframes: {
      spin: {
        to: { transform: 'rotate(360deg)' },
      },
      flicker: {
        '0%, 100%': { opacity: '1' },
        '50%': { opacity: '0' },
      }
    }
  },
  plugins: [],
  safelist: [
    'grid-cols-1', 'grid-cols-2', 'grid-cols-3', 'grid-cols-4', 'grid-cols-5',
    'sm:grid-cols-1', 'sm:grid-cols-2', 'sm:grid-cols-3', 'sm:grid-cols-4','sm:grid-cols-5',
    'md:grid-cols-1', 'md:grid-cols-2', 'md:grid-cols-3', 'md:grid-cols-4', 'md:grid-cols-5',
    'lg:grid-cols-1', 'lg:grid-cols-2', 'lg:grid-cols-3', 'lg:grid-cols-4', 'lg:grid-cols-5',
  ],
} satisfies Config
